export const NotificationBellIcon = ({ className }: { className?: string }) => (
    <svg name="NotificationBell" className={className} width="16" height="16" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 9V14C18 15.657 19.344 17 21 17V18H3V17C4.656 17 6 15.657 6 14V9C6 5.686 8.686 3 12 3C15.314 3 18 5.686 18 9ZM11.9999 21C10.5239 21 9.24793 20.19 8.55493 19H15.4449C14.7519 20.19 13.4759 21 11.9999 21Z"
        />
    </svg>
);
